/**
 * 公共配置文件
 */

import dev from './dev.env';
import pre from './pre.env';
import prod from './prod.env';

let config = null;

if (process.env.NODE_ENV === 'development') {
  config = dev;
  console.log('开发环境', config);
} else {
  if (process.env.VUE_APP_ENV === 'dev') {
    config = dev;
    console.log('线上环境： dev', config);
  } else if (process.env.VUE_APP_ENV === 'pre') {
    config = pre;
    console.log('线上环境： pre', config);
  } else if (process.env.VUE_APP_ENV === 'prod') {
    config = prod;
  }
}

export default {
  api: config.api,
  cdn: config.cdn,
  log: config.log,
  logger: config.logger,
  headers: config.headers,
  app: config.app,
  gateway: config.gateway,
  userInfo: config.userInfo,
  dlsIds: config.dlsIds,
  url: config.url,
  hostName: config.zhaonaxueHostName,
  zhaonaxueUrl: config.zhaonaxueUrl,
  routeUrl: config.routeUrl,
  scanToSign: config.scanToSign
};
